// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__26G_x","buttons":"PendingPaymentAlert_buttons__2djPh"};